import api from '@/services/api'

export default function() {
    return api.clientData('user_type') == 1
}